import { useEffect } from 'react'

import { useTranslation } from 'react-i18next'

import { PrivacyPolicyModel } from 'shared/api/PrivacyPolicyModel'
import { previewPdfUrl } from 'shared/lib/pdf-preview'
import privacyPolicyStore from 'shared/store/privacy-policy-store'
import {
  useDialogBottomSheet,
  useErrorPopUpStatus,
} from 'shared/ui/dialog-bottom-sheet/lib'

export const usePrivacyPolicyDocument = () => {
  const { t } = useTranslation()
  const { closeDialog } = useDialogBottomSheet()
  const showError = useErrorPopUpStatus()

  useEffect(() => {
    void privacyPolicyStore.ensurePrivacyPolicy()
  }, [])

  const openPrivacyPolicy = async (field: keyof PrivacyPolicyModel) => {
    const policy = await privacyPolicyStore.ensurePrivacyPolicy()
    const url = policy?.[field]

    if (url) {
      previewPdfUrl(url)
      return
    }

    if (policy) {
      showError({ description: t('error_des') })
      return
    }

    showError({
      button: t('try_again'),
      description: t('error_des'),
      onClose: () => {
        closeDialog()
        void openPrivacyPolicy(field)
      },
    })
  }

  return { openPrivacyPolicy }
}
